// During prerendering usePathname can contain the proxy's internal route.
// Resolve relative hrefs against the public document on both SSR and hydration.
// Keep locale and trailing slash: both affect the browser's URL resolution.
export const documentPath = (pathname: string | null): string | undefined => {
  if (!pathname) return undefined
  const internal = pathname.match(/^\/(en|de|zz)\/[ab](?:-[^/]*)?(?=\/|$)(.*)$/)
  if (!internal) return pathname
  let path =
    internal[2]
      .replace(/^\/(?:stories|product-stories|home-stories|brand-stories|registry-stories|article-feeds)(?=\/|$)/, '')
      .replace(/^\/root(?=\/|$)/, '')
      .replace(/\/index$/, '') || '/'
  if (internal[1] !== 'en') path = `/${internal[1]}${path === '/' ? '' : path}`
  return path
}
